<template>
  <div class="Images" :style="max_height">
    <el-upload
        :action="url"
        :multiple="limit!==1"
        :data="{max_width:maxwidth?maxwidth:1000}"
        :on-exceed="onExceed"
        :limit="limit"
        :on-change="onChange"
        :headers="{token:this.$store.getters.getToken}"
        :on-success="onSuccess"
        :file-list="file_list"
        list-type="picture-card"
        with-credentials
        :before-upload="onImageCheck"
        auto-upload>
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}" style="width: 100%;height: 100%">
        <img style="width: 100%;height: 100%;object-fit: cover"
             class="el-upload-list__item-thumbnail"
             :src="file.url" alt="">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="onPictureMove(file,file_list,'left')">
            <i class="el-icon-back"></i>
          </span>
          <span class="el-upload-list__item-preview" @click="onPictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="el-upload-list__item-delete" @click="onRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
          <span class="el-upload-list__item-preview" @click="onPictureMove(file,file_list,'right')">
            <i class="el-icon-right"></i>
          </span>
        </span>
      </div>


    </el-upload>
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import {baseURL} from '@/utils/util'

  export default {
    props: ['limit', 'target', 'input', 'maxwidth'],
    data: () => {
      return {
        max_height: 'height:155px;max-height:155px',
        file_list: [],
        url: `${baseURL}/bk_image/upload`,
        dialogImageUrl: '',
        dialogVisible: false,
        input_lock: false
      }
    },
    watch: {
      input: {
        handler() {
          if (this.input.length !== 0 && !this.input_lock) {
            this.input.forEach(v => {
              if (v !== '') {
                this.file_list.push({
                  name: [...v.split('/')].pop(),
                  url: v,
                  response: {
                    temp_path: v
                  }
                })
              }
            });
            this.input_lock = true
          }
        },
        deep: true
      }
    },
    beforeMount() {
      let max_height = 0;
      if (this.limit <= 5) {
        max_height = 155
      } else if (this.limit === 6) {
        max_height = 310
      } else if (this.limit === 9) {
        max_height = 470
      }
      this.max_height = `height:${max_height}px;max-height:${max_height}px`
    },
    methods: {
      onPictureMove(f, fl, d) {
        let current_uid = f.uid;
        let file_list = [...fl];
        let current_index;
        fl.forEach((v, i) => {
          if (current_uid === v.uid) {
            current_index = i
          }
        });
        if (d === 'left' && current_index !== 0) {
          file_list.splice(current_index, 1);
          file_list.splice(current_index - 1, 0, f)
        } else if (d === 'right' && current_index !== fl.length - 1) {
          file_list.splice(current_index, 1);
          file_list.splice(current_index + 1, 0, f)
        }
        this.file_list = file_list;
        this.onChange()
      },

      onSuccess(r, f, fl) {
        this.file_list = fl;
        // eslint-disable-next-line no-console
        console.log(f.response)
      },
      onRemove(file) {
        let index;
        this.file_list.forEach((v, i) => {
          if (v.response.temp_path === file.response.temp_path) {
            index = i;
          }
        });
        this.file_list.splice(index, 1);
        this.onChange()
      },
      onChange() {
        let image_list = [];
        this.file_list.forEach(v => {
          if (v.response) {
            image_list.push(v.response.temp_path)
          }
        });
        this.$emit('output', {
          image_list: image_list,
          target: this.target
        })
      },
      onImageCheck(file) {
        const isImg = file.type.split('/')[0] === 'image';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isImg) {
          this.$message.error('Only Image file can be uploaded!');
        }
        if (!isLt2M) {
          this.$message.error('Image size should be under 2MB!');
        }
        return isImg && isLt2M;
      },
      onPictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      onExceed() {
        this.$message.warning(`Only ${this.limit} images can be upload for this section!`);
      },
    }
  };
</script>

<style scoped>
  .Images {
    overflow: hidden;
  }
</style>